<mat-slide-toggle
  [color]="'accent'"
  [checked]="themesService.isDarkTheme"
  (toggleChange)="themesService.switchLightDarkTheme()"
  [labelPosition]="'before'">
  {{ sliderText }}
</mat-slide-toggle>
